import { SEARCH, SORT } from 'constants/FilterConstants';
import type { PayloadAction } from 'modules/global/generic.types';
import type { FilterPayload } from 'modules/global/reducers/filterSliceAdapter';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/messagingAccounts/actionTypes';
import { DEFAULT_SORT } from 'modules/messagingAccounts/constants';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export type MessagingAccountsFilters = {
  [SEARCH]: string | null;
  [SORT]: string;
};

const emptyState: MessagingAccountsFilters = {
  [SEARCH]: null,
  [SORT]: DEFAULT_SORT,
};

const filterAdapter = filterSliceAdapter(emptyState);

const setFilter = (state: MessagingAccountsFilters, action: PayloadAction<FilterPayload<MessagingAccountsFilters>>) =>
  (action.payload.field === SORT && !action.payload.value
    ? { ...state, [SORT]: DEFAULT_SORT }
    : filterAdapter.setFilter(state, action));

export default createReducer<MessagingAccountsFilters>(filterAdapter.getInitialState(), {
  [types.SET_DASHBOARD_FILTER]: setFilter,
  [types.CLEAR_DASHBOARD_FILTERS]: filterAdapter.resetFilters,
  [LOCATION_CHANGE]: filterAdapter.resetFilters,
});
